/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PharmacyPreferredFaxRequest
 */
export interface PharmacyPreferredFaxRequest {
    /**
     * Preferred fax number to set on the pharmacy. Send an empty string to clear the override.
     * @type {string}
     * @memberof PharmacyPreferredFaxRequest
     */
    preferred_fax: string;
}

/**
 * Check if a given object implements the PharmacyPreferredFaxRequest interface.
 */
export function instanceOfPharmacyPreferredFaxRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "preferred_fax" in value;

    return isInstance;
}

export function PharmacyPreferredFaxRequestFromJSON(json: any): PharmacyPreferredFaxRequest {
    return PharmacyPreferredFaxRequestFromJSONTyped(json, false);
}

export function PharmacyPreferredFaxRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyPreferredFaxRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preferred_fax': json['preferred_fax'],
    };
}

export function PharmacyPreferredFaxRequestToJSON(value?: PharmacyPreferredFaxRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preferred_fax': value.preferred_fax,
    };
}

